// src/belediye/components/mesajlasma/useKlavyeAlani.js
// FAZ-73 — MOBİLDE MESAJ KUTUSU KLAVYENİN ÜSTÜNDE KALIR (WhatsApp mantığı).
//
// SORUN. Tam-ekran sohbet `position: fixed; inset: 0` ile çizilir. `fixed`
// LAYOUT viewport'a göre yerleşir; yazılım klavyesi ise VISUAL viewport'u
// küçültür. Yani klavye açılınca kap eskisi kadar uzun kalır, alt ucu —
// yazı kutusu ve Gönder — klavyenin ALTINDA kalır. Kullanıcı yazdığını
// göremez, Gönder'e basamaz.
//
// ÇÖZÜM. Kabın boyunu ve üst kenarını VISUAL viewport'tan okuyup CSS
// değişkenine yazıyoruz:
//     --kb-h   → o an GÖRÜNEN yükseklik (klavye açıkken kısalır)
//     --kb-top → görünen alanın belge tepesinden kayması (iOS'ta klavye
//                açılınca tarayıcı sayfayı kendisi kaydırabiliyor)
// Kap bu ikisini kullanınca klavyenin üstünde kalan alana TAM oturur; içerideki
// flex düzeni (mesajlar esner, composer esnemez) zaten kutuyu en alta yapıştırır.
//
// NEDEN `100dvh` YETMİYOR: dvh "dinamik viewport" birimidir ama tarayıcı
// çubuklarını izler, YAZILIM KLAVYESİNİ İZLEMEZ. iOS Safari'de klavye dvh'yi
// hiç değiştirmez. Bu yüzden ölçüm JS'ten gelmek zorunda.
//
// NEDEN `interactive-widget=resizes-content` YETMİYOR: yalnız Chrome/Android
// tarafında ve viewport meta'sını değiştirmeyi gerektiriyor — bu tüm sistemi
// etkiler. Buradaki çözüm sayfa bazında ve iOS'ta da çalışır.
//
// jsdom'da `visualViewport` yoktur → kanca sessizce hiçbir şey yapmaz.
import { useEffect } from "react";

export const KB_YUKSEKLIK = "--kb-h";
export const KB_UST = "--kb-top";

export default function useKlavyeAlani(aktif, kokRef = null) {
  useEffect(() => {
    if (!aktif) return undefined;
    const vv = typeof window !== "undefined" ? window.visualViewport : null;
    if (!vv) return undefined;

    const kok = document.documentElement;
    let oncekiYukseklik = vv.height;

    const uygula = () => {
      const h = Math.round(vv.height);
      kok.style.setProperty(KB_YUKSEKLIK, `${h}px`);
      kok.style.setProperty(KB_UST, `${Math.round(vv.offsetTop)}px`);

      // Alan KÜÇÜLDÜYSE klavye açılmıştır: son mesaj klavyenin altında
      // kalmasın diye sohbeti dibe çek. (Büyürken dokunmuyoruz — kullanıcı
      // eski mesajlara bakıyor olabilir.)
      if (h < oncekiYukseklik - 60) {
        const liste = kokRef?.current?.querySelector(".msj-msgs");
        if (liste) liste.scrollTop = liste.scrollHeight;
      }
      oncekiYukseklik = h;
    };

    uygula();
    vv.addEventListener("resize", uygula);
    vv.addEventListener("scroll", uygula);
    return () => {
      vv.removeEventListener("resize", uygula);
      vv.removeEventListener("scroll", uygula);
      kok.style.removeProperty(KB_YUKSEKLIK);
      kok.style.removeProperty(KB_UST);
    };
  }, [aktif, kokRef]);
}
